import { render } from "./Paiement.vue?vue&type=template&id=22110634&ts=true"
import script from "./Paiement.vue?vue&type=script&lang=ts"
export * from "./Paiement.vue?vue&type=script&lang=ts"

import "./Paiement.vue?vue&type=style&index=0&id=22110634&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__